import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { processTableData } from './utils';

const Cell = styled.div`
  border-bottom: 1px solid ${p => p.theme.product.specs.borderColor};
  color: ${p => p.theme.product.specs.color};
  font-family: ${p => p.theme.font.sourceSans};
  font-size: 13px;
  line-height: 16px;
  padding: 13px 4px;
  text-align: center;
  flex: 0 0 auto;
  white-space: nowrap;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  align-items: flex-end;
  background-color: ${p => p.theme.product.specs.headerBackground};
  color: ${p => p.theme.product.specs.headerColor};
  display: flex;
  flex: 1 0 auto;
  font-family: ${p => p.theme.font.metaOt};
  font-size: 14px;
  font-weight: bold;
  justify-content: center;
  line-height: 16px;
  padding: 4px;
  text-align: center;
  white-space: pre-line;
`;

const Wrapper = styled.div`
  display: flex;
  margin: 20px 0;
  margin-bottom: ${p => (p.footNote ? '5px' : '40px')};
  overflow-x: auto;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Table = ({ footNote, table }) => {
  const processed = processTableData(table);
  return (
    <Wrapper footNote={footNote}>
      {processed.map(column => (
        <Column cols={processed.length} key={column.header}>
          <Header>{column.header}</Header>
          {column.data.map((cell, i) => (
            <Cell key={i}>{cell}</Cell>
          ))}
        </Column>
      ))}
    </Wrapper>
  );
};

Table.propTypes = {
  footNote: PropTypes.bool,
  table: PropTypes.string.isRequired
};

Table.defaultProps = {
  footNote: false
};

export default Table;
